<template>
    <div class="card">
        <p class="form__label">$PLAT</p>
    
    
      <!-- 
          <p>Price: {{ formattedPrice }}</p>
          <p>Market Cap: {{ formattedMarketCap }}</p>
      -->
    


      <div v-if="formattedPrice">
      <a href="https://app.uniswap.org/explore/tokens/polygon/0x6ec063057ee3d6fe80f913204172762922d507cc?chain=polygon&utm_source=share-tdp&utm_medium=web" class="contact-link" target="_blank"> <p>Price: $ {{ formattedPrice }}</p></a>
      </div>

      <div v-if="formattedMarketCap">
      <a href="https://app.uniswap.org/explore/tokens/polygon/0x6ec063057ee3d6fe80f913204172762922d507cc?chain=polygon&utm_source=share-tdp&utm_medium=web" class="contact-link" target="_blank"> <p>Market Cap: {{ formattedMarketCap }}</p></a>
      </div>


    
    </div>
  </template>
  
  <script>
  import axios from 'axios';

  export default {
    data() {
      return {
        price: null,
        marketCap: null,
        formattedPrice: null,
        formattedMarketCap: null,
      };
      
    },mounted() {

      
      window.addEventListener('scroll', this.handleScroll);

        axios
          .get(
            'https://api.geckoterminal.com/api/v2/simple/networks/polygon_pos/token_price/0x6EC063057eE3D6fE80f913204172762922d507Cc',
            {
              headers: {
                'accept': 'application/json',
              },
            }
          )
          .then(data => {

            console.log('Data:', data);

        if (data.data && data.data.data && data.data.data.attributes && data.data.data.attributes.token_prices) {
          this.formattedPrice = data.data.data.attributes.token_prices['0x6ec063057ee3d6fe80f913204172762922d507cc'];


          this.formattedPrice = Math.trunc(this.formattedPrice  * 1e10) / 1e10;
          this.formattedPrice = this.formattedPrice.toFixed(10);

          this.formattedMarketCap = (this.formattedPrice * 50000000000000).toLocaleString('en-US');
          
          
        } else {
          console.error('Struct error:', data);
        }
        console.log("Price: " + this.token_prices);
      })
      .catch(error => {
        console.error('Error:', error);
      });

    
  },
    created() {
      


    },
    methods: {
      formatNumber(number) {
        // Converte o n�mero para nota��o decimal com 8 casas decimais
        return parseFloat(number).toFixed(8);
      },
      formatMarketCap(marketCap) {
        // Fun��o para formatar o market cap abreviado
        const suffixes = ['', 'K', 'M', 'B', 'T'];
        let suffixIndex = 0;
        while (marketCap >= 1000 && suffixIndex < suffixes.length - 1) {
          marketCap /= 1000;
          suffixIndex++;
        }
        return marketCap.toFixed(1) + suffixes[suffixIndex];
      }
    },
  };
  </script>
  
<style scoped>
body {
  font-family: 'Roboto', sans-serif;
  background-color: #000000;;
  margin: 0;
  padding: 0;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header h1 {
  color: white;
  font-size: 2.5rem;
  text-align: center;
  margin: 0;
  padding: 0 20px;
  background-color: rgba(0, 0, 0, 0.5); 
  border-radius: 10px;
  
}



.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-left: 20px;
  margin-bottom: 20px;
  width: 95%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form__label {
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #555;
  text-align: center;
}

.info p {
  margin: 5px 0;
  color: #333;
}

.form__input, .form__input_text_big {
  font-size: 1rem;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-width: 400px;
  margin: 10px 0;
  box-sizing: border-box;
}

.form__input2 {
  font-size: 1rem;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-width: 600px;
  margin: 10px 0;
  box-sizing: border-box;
  text-align: center
}

.form__input_text_big {
  font-size: 1.5rem;
}



.btn {
  border: none;
  font-family: 'Lato';
  font-size: inherit;
  color: inherit;
  background: none;
  cursor: pointer;
  padding: 25px 80px;
  display: inline-block;
  margin: 15px 30px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  outline: none;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

.btn:after {
  content: '';
  position: absolute;
  z-index: -1;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

/* Pseudo elements for icons */
.btn:before {
  font-family: 'FontAwesome';
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  position: relative;
  -webkit-font-smoothing: antialiased;
}


/* Icon separator */
.btn-sep {
  padding: 25px 60px 25px 120px;
}

.btn-sep:before {
  background: rgba(0,0,0,0.15);
}

/* Button 1 */
.btn-1 {
  background: #3498db;
  color: #fff;
}

.btn-1:hover {
  background: #2980b9;
}

.btn-1:active {
  background: #2980b9;
  top: 2px;
}

.btn-1:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Button 2 */
.btn-2 {
  background: #2ecc71;
  color: #fff;
}

.btn-2:hover {
  background: #27ae60;
}

.btn-2:active {
  background: #27ae60;
  top: 2px;
}

.btn-2:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Button 3 */
.btn-3 {
  background: #e74c3c;
  color: #fff;
}

.btn-3:hover {
  background: #c0392b;
}

.btn-3:active {
  background: #c0392b;
  top: 2px;
}

.btn-3:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Button 3 */
.btn-4 {
  background: #34495e;
  color: #fff;
}

.btn-4:hover {
  background: #2c3e50;
}

.btn-4:active {
  background: #2c3e50;
  top: 2px;
}

.btn-4:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Icons */

.icon-cart:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

.icon-heart:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

.icon-info:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

.icon-send:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}


</style>